import store, {FETCH_INITIAL} from './index';
import registerShortcuts from 'store/registerShortcuts';
import {modules, actions} from 'store/modulesForStore';
import sellerStore from './indexSeller';
import {modules as sellerStoreModules} from 'store/modulesForSellerStore';


export function initMainStoreModules () {


  Object.entries(modules).forEach(([name, module]) => {
    store.registerModule(name, module);
  });

  const rootActionsModule = {
    actions: {
      async [FETCH_INITIAL] (context) {
        await Promise.all([
          context.dispatch(`enums/${actions.FETCH_ENUMS}`, ['currencies', 'timezones']),
          context.dispatch(`channels/${actions.FETCH_CHANNELS}`),
          context.dispatch(`channels/${actions.FETCH_WA_PROVIDERS}`),
          context.dispatch(`roles/${actions.FETCH_ROLES_LIST}`),
          context.dispatch(`user/${actions.FETCH_USER_NOTES}`),
          (async () => {
            try {
              await context.dispatch(`releaseNotes/${actions.FETCH_RELEASE_NOTES}`);
            } catch (e) {
              console.warn(`Failed to load release notes [${e.message}]`);
            }
          })()
        ]);
      }
    }
  };

  store.registerModule('rootActions', rootActionsModule);

  registerShortcuts(store);
}

export function initSellerStoreModules () {
  Object.entries(sellerStoreModules).forEach(([name, module]) => {
    sellerStore.registerModule(name, module);
  });
}
